// country -> state/province code
export var ageRestrictions = {
  "default": 21,
  US: {
    "default": 21
  },
  CA: {
    "default": 21,
    AB: 18,
    // Alberta
    BC: 19,
    // British Columbia
    MB: 19,
    // Manitoba
    NB: 19,
    // New Brunswick
    NL: 19,
    // Newfoundland and Labrador
    NT: 19,
    // Northwest Territories
    NS: 19,
    // Nova Scotia
    NU: 19,
    // Nunavut
    ON: 19,
    // Ontario
    PE: 19,
    // Prince Edward Island
    QC: 21,
    // Quebec
    SK: 19,
    // Saskatchewan
    YT: 19 // Yukon
  }
};